var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUdhaarU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6458 3.50694C13.6944 3.11806 13.8403 2.77778 14.1319 2.48611C14.375 2.24306 14.6667 2.09722 14.9583 2H17V5.35417H15.3472C14.8611 5.35417 14.4722 5.20833 14.1806 4.86806C13.8889 4.57639 13.7431 4.23611 13.6944 3.84722V3.50694H13.6458ZM3.09722 2.04861H5.09028C5.43056 2.09722 5.67361 2.29167 5.91667 2.53472C6.20833 2.82639 6.35417 3.16667 6.40278 3.55556V3.89583C6.35417 4.28472 6.20833 4.625 5.91667 4.91667C5.57639 5.25694 5.1875 5.40278 4.75 5.40278H3.09722V2.04861ZM15.0069 16.2431C13.6944 17.6042 11.9931 18.2847 10 18.2847C8.00694 18.2847 6.35417 17.6042 4.99305 16.2431C3.68055 14.8819 3 13.1806 3 11.1875V7.00694H6.35417C6.35417 7.00694 6.35417 11.7222 6.35417 11.8194C6.45139 12.6458 6.79167 13.375 7.42361 14.0069C8.15278 14.7361 8.97917 15.0764 9.95139 15.0764C10.9236 15.0764 11.75 14.7361 12.4792 14.0069C12.9167 13.5694 13.2569 13.0833 13.4028 12.5C13.5 12.1597 13.5486 11.8194 13.5486 11.4306V7.00694H16.9028V11.1875C17 13.1806 16.3194 14.8819 15.0069 16.2431Z",
    fill: "#3B0C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdhaarU);
export default __webpack_public_path__ + "static/media/UdhaarU.a9a7108c.svg";
export { ForwardRef as ReactComponent };